import Vue from 'vue'

export default {

  all (conditions = {}) {
    const like = escape(conditions.like)
    return Vue.http.get(
      `${process.vars.BACKEND_HOST}/api/ui/vendors?search=${like}`
    )
  },
  autocomplete (searchTerm) {
    return Vue.http.get(
      `${process.vars.BACKEND_HOST}/api/ui/vendors/autocomplete?search=${searchTerm || ''}`
    )
  },
  get (id) {
    return Vue.http.get(
      `${process.vars.BACKEND_HOST}/api/ui/vendors/${id}`
    )
  }
}
